<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>特权配置</el-breadcrumb-item>
    </el-breadcrumb>
    <ex-table
      ref="table"
      :new-btn="handleAdd"
      :load-and-request="false"
      :request="fetchData"
    >
      <ex-table-column
        prop="id"
        label="ID"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="orderNo"
        label="排序"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="title"
        label="标题"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="remark"
        label="说明"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="iconUrl"
        label="图标"
        align="center"
        :data-type="DataType.IMAGE"
      ></ex-table-column>
      <ex-table-column
        prop="status"
        label="状态"
        align="center"
        data-type="select"
        :options="statusOptions"
      ></ex-table-column>
      <ex-table-column
        prop="createTime"
        label="创建时间"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="createTime"
        label="操作"
        align="center"
      >
        <template #default="{row}">
          <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" size="small" @click="handleDelete(row)">删除</el-button>
        </template>
      </ex-table-column>
    </ex-table>

    <el-dialog
      title="推荐配置"
      :visible.sync="show"
      width="50%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @close="close"
    >
      <el-form :model="form" ref="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="form.title" placeholder="请输入标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-switch
                v-model="form.status"
                size="large"
                active-text="开启"
                inactive-text="禁用"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="排序" prop="orderNo">
              <el-input-number v-model="form.orderNo" placeholder="请输入排序"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图标" prop="iconUrl">
              <single-image-upload v-model="form.iconUrl" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="描述文案" prop="remark">
            <el-input v-model="form.remark" placeholder="请输入描述文案"></el-input>
          </el-form-item>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
          <el-button @click="close">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  addPrivilege,
  addSetting,
  deleteMemberCombo, deletePrivilege,
  privilegeList,
  settingList,
  updatePrivilege,
  updateSetting
} from "../../api/configMG";
import {isJsonString} from "../../utils/util";
import {DataType} from "../../components/ExTable/ExTableEnum";
import SingleImageUpload from "../../components/SingleImageUpload.vue";

export default {
  components: {SingleImageUpload},
  computed: {
    DataType() {
      return DataType
    }
  },
  data() {
    return {
      show: false,
      form: {
        title: '',
        orderNo: undefined,
        iconUrl: '',
        remark: '',
        status: 0
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
        ],
        orderNo: [
          {required: true, message: '请输入排序', trigger: 'blur'},
        ],
        iconUrl: [
          {required: true, message: '请上传图标', trigger: 'blur'},
        ],
        remark: [
          {required: true, message: '请输入描述文案', trigger: 'blur'},
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'blur'},
        ],
      },
      statusOptions: [
        { value: 0, label: '禁用' },
        { value: 1, label: '开启' }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.table.search();
    })
  },
  methods: {
    async fetchData(params) {
      let res = await privilegeList(params)
      return new Promise((c) => {
        c({
          records: res.data.list,
          total: res.data.total
        })
      })
    },
    close() {
      this.show = false
      this.$refs.form.resetFields();
      this.form = {
        title: '',
        orderNo: undefined,
        iconUrl: '',
        remark: '',
        status: 0
      }
    },
    handleAdd() {
      this.show = true
    },
    handleEdit(row) {
      this.form = {...row, status: !!row.status}
      this.show = true
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.status = this.form.status ? 1 : 0;
          if (this.form.id) {
            updatePrivilege(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                this.close();
                this.$refs.table.search();
              } else {
                this.$message.error(res.message);
              }
            })
          } else {
            addPrivilege(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '添加成功!'
                });
                this.close();
                this.$refs.table.search();
              } else {
                this.$message.error(res.message);
              }
            })
          }
        }
      })
    },
    handleDelete(row) {
      this.$confirm('是否删除该特权?', '提示', {
        type: 'warning'
      }).then(() => {
        deletePrivilege({ids: row.id}).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.$refs.table.search();
          } else {
            this.$message.error(res.message);
          }
        })
      }).catch(() => {});
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/machine/Privilege.vue